export const DOCUMENT_CATEGORIES = [
  ["source_cv", "CV"],
  ["education_certificate", "Education certificate"],
  ["identity_document", "Identity document"],
  ["primary_document", "Primary document"],
  ["passport", "Passport"],
  ["employment_contract", "Employment contract"],
  ["employer_letter", "Employer letter"],
  ["payslip", "Payslip"],
  ["degree_certificate", "Degree certificate"],
  ["transcript", "Transcript"],
  ["supporting_evidence", "Supporting evidence"],
  ["qualification", "Qualification"],
  ["financial", "Financial"],
  ["unspecified", "Unspecified"],
];

export const normaliseDocumentCategory = (value) => String(value || "")
  .trim().toLowerCase().replace(/[\s_-]+/g, "_").replace(/^_+|_+$/g, "");

export const documentCategoryLabel = (value) => {
  const categoryLabels = Object.fromEntries(DOCUMENT_CATEGORIES);
  const category = normaliseDocumentCategory(value);
  return categoryLabels[category] || humanDocumentStatus(category);
};

export const buildDocumentQuery = (filters) => Object.fromEntries(
  Object.entries(filters)
    .map(([key, value]) => [key, String(value || "").trim()])
    .filter(([, value]) => value !== "")
    .map(([key, value]) => [key, key === "category" ? normaliseDocumentCategory(value) : value])
);

export const activeDocumentFilters = (filters) => {
  const query = buildDocumentQuery(filters);
  return [
    query.candidate && `Candidate: ${query.candidate}`,
    query.category && `Category: ${documentCategoryLabel(query.category)}`,
    query.verification_status && `Status: ${humanDocumentStatus(query.verification_status)}`,
    query.uploaded_from && `Uploaded from: ${query.uploaded_from}`,
    query.uploaded_to && `Uploaded to: ${query.uploaded_to}`,
  ].filter(Boolean);
};

export const humanDocumentStatus = (value) => String(value || "Not recorded")
  .replace(/[\s_-]+/g, " ").replace(/^./, (letter) => letter.toUpperCase());
